import { RetryPlugin } from '@module-federation/retry-plugin'

const RETRY_TIMES = 3
const RETRY_DELAY_MS = 1000

export default () => RetryPlugin({
  retryTimes: RETRY_TIMES,
  retryDelay: RETRY_DELAY_MS,
  addQuery: ({ times, originalQuery }) => {
    const params = new URLSearchParams(originalQuery)
    params.set('retry', times.toString())
    params.set('t', Date.now().toString())
    return params.toString()
  },
  onRetry: ({ times, url }) => {
    console.warn(`[MFE] Retry ${times}/${RETRY_TIMES} for ${url}`)
  },
  onError: ({ url }) => {
    console.error(`[MFE] Failed to load ${url} after ${RETRY_TIMES} retries`)
  }
})
